import PropTypes from 'prop-types';
import { formatMoney } from '../utils';
import { toggleSummarizeTaxes, splitShipIsLoading } from '../redux/splitShip';
import LabelledCheckbox from './LabelledCheckbox';
import { useSelector, useDispatch } from 'react-redux';

const SplitShipOrderTaxes = ({ order, splitShip, showTaxAmounts, onUpdateOrder, avalaraOrderTaxButton }) => {
    const loading = useSelector(splitShipIsLoading);
    const dispatch = useDispatch();
    const splitShipActions =
        <tr>
            <td colSpan={2} style={{ width: '100%' }}>
                <div style={{ width: '100%', textAlign: 'start' }}>
                    {order.order_type === 'ESTIMATE' && <LabelledCheckbox
                        style={{ display: 'inline-block', textAlign: 'start', whiteSpace: 'nowrap' }}
                        label="Hide Totals"
                        disabled={order.locked}
                        value={order.hide_totals}
                        onChange={onUpdateOrder(order.order_id, 'hide_totals', order.hide_totals)}
                        data-test-id="splitShip-summary-hideTotals-checkbox"
                    />}
                    <LabelledCheckbox
                        style={{ display: 'inline-block', textAlign: 'start', whiteSpace: 'nowrap' }}
                        label="Show Breakdown on invoice"
                        value={splitShip.summarize_taxes ? 0 : 1}
                        onChange={() => dispatch(toggleSummarizeTaxes({ splitShipId: splitShip.split_ship_id }))}
                        disabled={ order.locked || loading }
                        data-test-id="splitShip-summary-showBreakdown-checkbox"
                    />
                </div>
            </td>
        </tr>;
    if (splitShip.summarize_taxes) {
        const taxAmounts = order.tax_amounts.reduce((sum, ta) => sum + ta.amount, 0);
        return (<>
            {showTaxAmounts && <tr>
                <td>Total Tax</td>
                <td>${formatMoney(taxAmounts)}</td>
            </tr>}
            { avalaraOrderTaxButton }
            <tr>
                <td>Total</td>
                <td>${formatMoney(order.total_total)}</td>
            </tr>
            {splitShipActions}
        </>);
    }

    return (<>
        {showTaxAmounts && order.tax_amounts.map((ta, i) => <tr key={i}>
            <td>{ta.label}</td>
            <td>${formatMoney(ta.amount)}</td>
        </tr>)}
        { avalaraOrderTaxButton }
        <tr>
            <td>Total</td>
            <td>${formatMoney(order.total_total)}</td>
        </tr>
        {splitShipActions}
    </>);
};
SplitShipOrderTaxes.propTypes = {
    order: PropTypes.shape({
        order_id: PropTypes.string.isRequired,
        tax_amounts: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string,
            amount: PropTypes.number,
        })).isRequired,
        total_total: PropTypes.string.isRequired,
        locked: PropTypes.number,
        hide_totals: PropTypes.number,
    }).isRequired,
    splitShip: PropTypes.shape({
        split_ship_id: PropTypes.string.isRequired,
        summarize_taxes: PropTypes.number,
    }).isRequired,
    showTaxAmounts: PropTypes.bool,
    onUpdateOrder: PropTypes.func.isRequired,
    avalaraOrderTaxButton: PropTypes.node,
};
export default SplitShipOrderTaxes;
